import { useDatasourceId } from '@/hooks';
import {
  useGetCreditsConsumptionInfoQuery,
  useGetSubscriptionDetailsQuery,
} from '@/features/credits/apiSlice';

export const useFetchCreditsData = () => {
  const datasourceId = useDatasourceId();

  const { data: subscriptionDetails, isLoading: isSubscriptionDetailsLoading } =
    useGetSubscriptionDetailsQuery(datasourceId);

  const {
    data: creditsConsumptionInfo,
    isLoading: isCreditsConsumptionInfoLoading,
  } = useGetCreditsConsumptionInfoQuery(datasourceId);

  const isLoading =
    isSubscriptionDetailsLoading || isCreditsConsumptionInfoLoading;

  return {
    subscriptionDetails,
    creditsConsumptionInfo,
    isLoading,
  };
};
